import { render, staticRenderFns } from "./LoadingModule.vue?vue&type=template&id=860fba12&scoped=true&"
import script from "./LoadingModule.vue?vue&type=script&lang=js&"
export * from "./LoadingModule.vue?vue&type=script&lang=js&"
import style0 from "./LoadingModule.vue?vue&type=style&index=0&id=860fba12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fba12",
  null
  
)

component.options.__file = "LoadingModule.vue"
export default component.exports